import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2_27)", children: [
    /* @__PURE__ */ s.jsx(
      "mask",
      {
        id: "mask0_2_27",
        style: {
          maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 0,
        width: 40,
        height: 40,
        children: /* @__PURE__ */ s.jsx("path", { d: "M0 0H40V40H0V0Z", fill: "white" })
      }
    ),
    /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2_27)", children: [
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M1 20C1 9.507 9.507 1 20 1C30.493 1 39 9.507 39 20C39 30.493 30.493 39 20 39C9.507 39 1 30.493 1 20Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M1 20C1 9.507 9.507 1 20 1C30.493 1 39 9.507 39 20C39 30.493 30.493 39 20 39C9.507 39 1 30.493 1 20Z",
          stroke: "black",
          strokeWidth: 2
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M24.4531 24.325C25.6001 24.338 26.8331 24.718 28.0901 25.695L24.3751 20.345C23.8925 19.6314 23.2424 19.047 22.4816 18.6431C21.7208 18.2391 20.8725 18.0278 20.0111 18.0278C19.1496 18.0278 18.3014 18.2391 17.5405 18.6431C16.7797 19.047 16.1296 19.6314 15.6471 20.345L10.3481 27.975L8.48206 30.66C11.2681 32.742 15.1561 32.087 17.1641 29.198L18.2561 27.625L18.2661 27.612C18.3666 27.4678 18.4841 27.3362 18.6161 27.22L18.6191 27.218C18.7211 27.035 22.1211 24.29 24.4531 24.325Z",
          fill: "url(#paint0_linear_2_27)"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M31.522 30.634C30.4758 31.4223 29.202 31.8497 27.892 31.852C27.042 31.852 26.196 31.671 25.412 31.32C24.3754 30.851 23.4862 30.1084 22.84 29.172L21.766 27.624C21.6822 27.5042 21.5871 27.3927 21.482 27.291C21.1016 26.9208 20.5956 26.7076 20.065 26.6939C19.5344 26.6801 19.0181 26.8669 18.619 27.217C19.468 26.325 21.709 24.284 24.452 24.326C25.599 24.338 26.832 24.718 28.089 25.696L28.094 25.698L31.522 30.634Z",
          fill: "#009BD1"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          opacity: 0.35,
          d: "M28.09 25.695C24.542 24.591 22.368 26.324 21.482 27.291C21.1016 26.9208 20.5956 26.7076 20.065 26.6939C19.5344 26.6802 19.0181 26.8669 18.619 27.217C19.821 25.953 23.83 22.377 28.09 25.695Z",
          fill: "url(#paint1_linear_2_27)"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M20.003 16.509C22.047 16.509 23.703 14.791 23.703 12.673C23.703 10.554 22.047 8.83701 20.003 8.83701C17.96 8.83701 16.303 10.554 16.303 12.673C16.303 14.792 17.96 16.509 20.003 16.509Z",
          fill: "url(#paint2_linear_2_27)"
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint0_linear_2_27",
        x1: 8.48306,
        y1: 24.952,
        x2: 28.0901,
        y2: 24.952,
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#4C9968" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 0.334, stopColor: "#2F9A90" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 0.778, stopColor: "#0D9BBF" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#009BD1" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint1_linear_2_27",
        x1: 26.142,
        y1: 21.71,
        x2: 20.661,
        y2: 29.67,
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", {}),
          /* @__PURE__ */ s.jsx("stop", { offset: 1, stopOpacity: 0 })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint2_linear_2_27",
        x1: 22.565,
        y1: 15.446,
        x2: 17.036,
        y2: 10.339,
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#D83547" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 0.043, stopColor: "#DC4147" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 0.167, stopColor: "#E75C48" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 0.291, stopColor: "#EF7049" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 0.416, stopColor: "#F37C49" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 0.542, stopColor: "#F58049" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#F0C84B" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2_27", children: /* @__PURE__ */ s.jsx("rect", { width: 40, height: 40, fill: "white" }) })
  ] })
] });
export {
  o as Z
};
